import { Box, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from "@mui/material";
import ScreenBanner from "../../../../components/ScreenBanner";
import { useState } from "react";
import IRequest from "../../../../types/IRequest";
import { IDataPesquisarCafe } from "../../../../types/api/cafe/pesquisar-lotes-cafe";
import { useMutation } from "react-query";
import axiosClient from "../../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import LoadingApiQuery from "../../../../components/LoadingApiQuery";
import YoutubeSearchedForIcon from '@mui/icons-material/YoutubeSearchedFor';
import TableMenuOptions from "../../../../components/TableMenuOptions";
import { Moment } from "moment";
import FiltrosCabecalho from "./FiltrosCabecalho";
import BtnExportarDados from "../../../../components/BtnExportarDados";
import DetalheLote from "./Dialogs/DetalheLote";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { IDataPublicos } from "../../../../types/api/geral/pesquisar-publicos";
import { extrairIdsComLabel } from "../../../../helpers/extrairIdsArray";
import PermissionGuard from "../../../../components/PermissionGuard";

export default function PageListaLoteCafe() {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [filtros, setFiltros] = useState<IFiltrosState>(defaultFiltrosValues)
    const [openModalDetalhe, setOpenModalDetalhe] = useState<IOpenModalDetalhe>({
        dado: null,
        dialogDetalheLote: false,
    })
    const [dataLotesCafe, setDataLotesCafe] = useState<IListaProdutos>({
        req: null,
        data: []
    })

    const verificarIdsValidosComLabel = (array: TFilterOptions[]): boolean => {
        return !array.some(item => item.id === null || Number.isNaN(item.id));
    }

    const paramsQuery = {
        pesquisar: filtros.pesquisar,
        ...(filtros.pesquisar_dado ? { codigo_publico: filtros.pesquisar_dado.codigo_publico, tipo_publico: filtros.pesquisar_dado.tipo_publico } : {}),
        ...(filtros.data_documento_inicio ? { data_documento_inicio: filtros.data_documento_inicio.format("YYYY-MM-DD") } : {}),
        ...(filtros.data_documento_fim ? { data_documento_fim: filtros.data_documento_fim.format("YYYY-MM-DD") } : {}),
        ...(verificarIdsValidosComLabel(filtros.grao_aspecto) ? { grao_aspecto_ids: extrairIdsComLabel(filtros.grao_aspecto) } : {}),
        ...(verificarIdsValidosComLabel(filtros.grao_bebida) ? { grao_bebida_ids: extrairIdsComLabel(filtros.grao_bebida) } : {}),
        ...(verificarIdsValidosComLabel(filtros.grao_cor) ? { grao_cor_ids: extrairIdsComLabel(filtros.grao_cor) } : {}),
        ...(verificarIdsValidosComLabel(filtros.grao_tipo) ? { grao_tipo_ids: extrairIdsComLabel(filtros.grao_tipo) } : {}),
        ...(!filtros.safra.includes("Todos(as)") ? { intervalos_safra: filtros.safra } : {})
    };

    //queries e mutations
    const { mutate: pesquisarLotesCafe, isLoading: isLoadingLotesCafe } = useMutation({
        mutationKey: ["listagem-pesquisar-lotes-cafe"],
        mutationFn: async (inputs?: IPesquisaLotesCafeInput) => await axiosClient.get("/pesquisar-lotes-cafe", {
            params: {
                page: (inputs?.pagina ?? 0 ?? page) + 1,
                limit: inputs?.linhasPorPag ?? rowsPerPage,
                ...paramsQuery
            }
        }),
        onError: (e) => {
            console.error(e)
            enqueueSnackbar("Erro ao buscar dados", { variant: "error" })
        },
        onSuccess: ({ data }) => setDataLotesCafe({ req: data, data: data?.data || [] })
    });
    //

    //função manipuladora
    const handleChangePage = (
        _: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number,
    ) => {
        setPage(newPage);
        pesquisarLotesCafe({ pagina: newPage })
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        const value = parseInt(event.target.value)
        setRowsPerPage(value);
        setPage(0);
        pesquisarLotesCafe({ pagina: 0, linhasPorPag: value })
    };

    const handleCallRequest = () => {
        setPage(0)
        pesquisarLotesCafe({ pagina: 0 })
    }

    const handleCloseModal = (dialog: keyof IOpenModalDetalhe) => {
        setOpenModalDetalhe((prevState) => ({
            ...prevState,
            dado: null,
            [dialog]: false,
        }));
    };

    const handleOpenModal = (
        value: IDataPesquisarCafe,
        dialog: keyof IOpenModalDetalhe
    ) => {
        setOpenModalDetalhe((prevState) => ({
            ...prevState,
            dado: value,
            [dialog]: true,
        }));
    };
    //

    return (
        <>
            <ScreenBanner color="#7D3600" title="Café" />
            <PermissionGuard permissionId="cafe.listar-lotes">
                <Container sx={{ mt: 6 }}>
                    <Typography variant="h5" align="center" mb={3}>Lista de lotes de café</Typography>

                    <FiltrosCabecalho
                        {...{ filtros }}
                        loadingQuery={isLoadingLotesCafe}
                        onSearchData={() => handleCallRequest()}
                        onChangeFiltro={(prop, value) => setFiltros(prevState => ({ ...prevState, [prop]: value }))}
                        onClearFiltros={() => {
                            setFiltros(defaultFiltrosValues)
                        }}
                    />

                    <TableContainer component={Paper} sx={{ mt: 2, width: "100%" }}>
                        {
                            isLoadingLotesCafe &&
                            <LoadingApiQuery />
                        }

                        {
                            (dataLotesCafe.data.length <= 0 && !isLoadingLotesCafe) &&
                            <Box display="flex" justifyContent="center" alignItems="center" gap={0.5} py={5}>
                                <Typography variant="subtitle1" color="gray">Para iniciar a pesquisa insira os filtros e aperte o botão</Typography>
                                <YoutubeSearchedForIcon fontSize="small" sx={{ color: "gray" }} />
                            </Box>
                        }

                        {
                            (dataLotesCafe.data.length > 0 && !isLoadingLotesCafe) &&
                            <>
                                <Box display="flex" alignItems="center" justifyContent="flex-end" p={2}>
                                    <BtnExportarDados
                                        tipoExportacao={["csv", "pdf"]}
                                        possuiQuery
                                        pathRequisicao="pesquisar-lotes-cafe"
                                        fileName="lotes_cafe"
                                        queryParams={paramsQuery}
                                        cabecalhoLabels={[
                                            { queryKey: "numero_lote", label: "Lote" },
                                            { queryKey: "tipo_publico", label: "Tipo público" },
                                            { queryKey: "codigo_publico", label: "Código público" },
                                            { queryKey: "nome_publico", label: "Produtor" },
                                            { queryKey: "data_documento", label: "Data documento" },
                                            { queryKey: "safra_inicial", label: "Safra inicio" },
                                            { queryKey: "safra_final", label: "Safra fim" },
                                            { queryKey: "grao_tipo_nome", label: "Tipo" },
                                            { queryKey: "grao_bebida_nome", label: "Bebida" },
                                            { queryKey: "grao_cor_nome", label: "Cor" },
                                            { queryKey: "grao_aspecto_nome", label: "Aspecto" },
                                        ]}
                                        formatos={{
                                            "Data documento": "data",
                                        }}
                                    />
                                </Box>

                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><b>Lote</b></TableCell>

                                            <TableCell><b>Produtor</b></TableCell>

                                            <TableCell><b>Safra</b></TableCell>

                                            <TableCell><b>Tipo</b></TableCell>

                                            <TableCell><b>Bebida</b></TableCell>

                                            <TableCell><b>Cor</b></TableCell>

                                            <TableCell><b>Aspecto</b></TableCell>

                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            dataLotesCafe.data.map((loteCafe, index) => {
                                                return (
                                                    <TableRow
                                                        key={index}
                                                        sx={{
                                                            cursor: "pointer",
                                                            transition: 'background-color 0.2s ease',
                                                            '&:last-child td, &:last-child th': { border: 0 },
                                                            "&:hover": {
                                                                backgroundColor: 'rgba(255,244,229,1)'
                                                            }
                                                        }}
                                                    >
                                                        <TableCell>{loteCafe.numero_lote}</TableCell>

                                                        <TableCell>{`${loteCafe.tipo_publico}${loteCafe.codigo_publico} - ${loteCafe.nome_publico}`}</TableCell>

                                                        <TableCell>{`${loteCafe.safra_inicial} - ${loteCafe.safra_final}`}</TableCell>

                                                        <TableCell>{loteCafe.grao_tipo_nome}</TableCell>

                                                        <TableCell>{loteCafe.grao_bebida_nome}</TableCell>

                                                        <TableCell>{loteCafe.grao_cor_nome}</TableCell>

                                                        <TableCell>{loteCafe.grao_aspecto_nome}</TableCell>

                                                        <TableCell>
                                                            <TableMenuOptions
                                                                menuItems={[
                                                                    {
                                                                        label: "Detalhes do lote",
                                                                        action: () =>
                                                                            handleOpenModal(
                                                                                loteCafe,
                                                                                "dialogDetalheLote"
                                                                            ),
                                                                        icon: <ArticleOutlinedIcon sx={{ color: "gray" }} />,
                                                                    },
                                                                ]}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })
                                        }
                                    </TableBody>
                                </Table>

                                <Box display="flex" alignItems="center" justifyContent="flex-end" p={2}>
                                    <TablePagination
                                        component="div"
                                        count={dataLotesCafe?.req?.total || 0}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        rowsPerPage={rowsPerPage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        labelRowsPerPage="Linhas por página"
                                        labelDisplayedRows={({ from, to, count }) => `Pag. ${page + 1}`}
                                    />
                                </Box>
                            </>
                        }
                    </TableContainer>
                </Container>
            </PermissionGuard>

            {openModalDetalhe.dialogDetalheLote && openModalDetalhe.dado && (
                <DetalheLote
                    value={openModalDetalhe.dado}
                    open={Boolean(openModalDetalhe.dialogDetalheLote)}
                    handleClose={() => handleCloseModal("dialogDetalheLote")}
                />
            )}
        </>
    )
}

export const defaultFiltrosValues = {
    pesquisar: '',
    pesquisar_label: "",
    pesquisar_dado: null,
    data_documento_fim: null,
    data_documento_inicio: null,
    grao_aspecto: [{ id: NaN, label: "Todos(as)" }],
    grao_bebida: [{ id: NaN, label: "Todos(as)" }],
    grao_cor: [{ id: NaN, label: "Todos(as)" }],
    grao_tipo: [{ id: NaN, label: "Todos(as)" }],
    safra: ["Todos(as)"],
}

export interface IFiltrosState {
    pesquisar: string,
    pesquisar_label: string,
    pesquisar_dado: IDataPublicos | null,
    data_documento_fim: Moment | null,
    data_documento_inicio: Moment | null,
    grao_aspecto: TFilterOptions[],
    grao_bebida: TFilterOptions[],
    grao_cor: TFilterOptions[],
    grao_tipo: TFilterOptions[],
    safra: string[]
}

type TFilterOptions = { label: string, id: number }

interface IOpenModalDetalhe {
    dado: IDataPesquisarCafe | null,
    dialogDetalheLote: boolean,
}

interface IListaProdutos {
    req: IRequest<IDataPesquisarCafe> | null
    data: IDataPesquisarCafe[]
}

interface IPesquisaLotesCafeInput {
    pagina?: number,
    linhasPorPag?: number,
}